import React from 'react';
import classNames from 'classnames';

import './style.scss';

const NodeTestimonial = ({ entity, className }) => {
  const classes = classNames(className, 'Testimonial', 'Testimonial--large');

  const title = entity.getIn(['title', 0, 'value']);
  const fieldQuote = entity.getIn(['field_quote', 0, 'value']);

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <h2 className="asH1 Testimonial__body">
        {fieldQuote}
      </h2>
      <p className="Testimonial__title">
        ~ {title}
      </p>
    </article>
  );
};


export default NodeTestimonial;
